import { getFilteredSkillIds } from './distributor-type';
import AxleRepairIcon from './skill-icons/axleRepair.svg';
import BodyConstructionIcon from './skill-icons/bodyConstruction.svg';
import EMobilityIcon from './skill-icons/eMobility.svg';
import HaldexDiagnosisIcon from './skill-icons/haldexDiagnosis.svg';

export const renderDistributorSkillIcon = (
  skillIdentifier: ReturnType<typeof getFilteredSkillIds>[number],
  skillTitle: string,
) => {
  const imageElement = document.createElement('img');
  switch (skillIdentifier) {
    case 'axleRepair':
      imageElement.src = AxleRepairIcon;
      break;
    case 'bodyConstruction':
      imageElement.src = BodyConstructionIcon;
      break;
    case 'eMobility':
      imageElement.src = EMobilityIcon;
      break;
    case 'haldexDiagnosis':
      imageElement.src = HaldexDiagnosisIcon;
      break;
  }
  imageElement.alt = skillTitle;
  return imageElement;
};
